<template>
    <div class="userOuter">
        <Header></Header>
        <div class="user">
            <div class="user_container">
                <div class="userLeft">
                    <ul>
                        <li v-for="(item, index) in lists" :key="index" 
                            :style="item.name === '编辑模型' ? 'display: none' : ''"
                            :class="['item', item.showBorderLine ? 'borderLine':''
                                // item.showBorderLine && item.name === '意见反馈' ? 'borderLine_advice':''
                            ]" >
                            <div @click=showBorder(index)>
                                <router-link :to="item.path">
                                    <span>{{ item.name }}</span>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                    <!-- <div></div> -->
                </div>
                <div class="userRight">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../../components/header/index.vue"

import { mapState } from 'vuex'
export default {
    data() {
        return {
            showBorderLine:false,
            lists:[
                {
                    id: 0,
                    path: '/user/user_info',
                    name: '个人信息',
                    showBorderLine:false
                },
                {
                    id: 1,
                    path: '/user/user_model',
                    name: '我的模型',
                    showBorderLine:false
                },
                {
                    id: 2,
                    path: '/user/user_project',
                    name: '我的项目',
                    showBorderLine:false
                },
                {
                    id: 3,
                    path: '/user/user_sub',
                    name: '我的收藏',
                    showBorderLine:false
                },
                {
                    id: 4,
                    path: '/user/user_upload',
                    name: '上传模型',
                    showBorderLine:false
                },
                {
                    id: 5,
                    path: '/user/model_edit',
                    name: '编辑模型',
                    showBorderLine:false
                }
            ]
        };
    },
    computed:{
        ...mapState(['userInformation'])
    },
    components:{
        Header
    },
    methods:{
        showBorder(i){
            // this.showBorderLine = true
            this.lists[i].showBorderLine = true
            // 其他的都为false
            this.lists.forEach((item,index)=>{
                if(index!=i){
                    item.showBorderLine = false
                }
            })
        },
        closeBorder(){
            this.lists.forEach((item,index)=>{
                item.showBorderLine = false
            })
        }
    },
    mounted(){
        this.$bus.$on('close', this.closeBorder)
    },
    created(){
        const userToken = window.localStorage.getItem("userToken")
        if(!userToken){
            this.$message.error("请先登录")
            this.$router.push("/")
        }
        // 判断当前路由
        this.lists.forEach((item,index)=>{
            if(item.path==this.$route.path){
                item.showBorderLine = true
            }
        })
        
        // console.log('当前路由', this.$route.path);
    }
}
</script>

<style scoped lang="less">
// 媒体查询
@media screen and (max-width: 1800px) {
    .user_container {
        width: 100%;
        // background-color: #54ceec;
    }
}
@media screen and (min-width: 1800px)  and (max-width: 2300px) {
    .user_container {
        width: 80%;
        // background-color: #54ec93;
    }
}
.userOuter{
    background-color: #E9E9EA;
    min-height: 100vh;
}
.user{
    // background-color: #E9E9EA;
    min-width: 1350px;
    padding-bottom: 5rem;
    // width: 100vw;
    // height: 100vh;
    .user_container {
        // width: 80%;
        padding-top: 3.06rem;
        margin: 0 auto;
        // background-color: aquamarine;
        display: flex;
        justify-content: center;

    }
}


.userLeft:hover{
    color: #54ceec;
}
.userLeft {
    /* width: 10%; */
    /* position: fixed; */
    height: 40%;
    // margin-right: 2rem;
    color: #999999;
    height: auto;
    padding-right: 1rem;
    ul{
        padding: 10px 0;
        border-radius: 10px;
        background-color: #ffffff;
    }
    .item{
        padding: 1rem 5.38rem 1rem 0;
        a{
            color: #999999;
        }
        a:hover{
            color: #54ceec;
        }
        span{
            // background-color: #999999;
            display: inline-block;
            padding-left: 1rem;
            // width: 4.5rem;
        }
    }
    .item:hover{
        color: #54ceec ;
    }
    .borderLine{
        span{
            // background-color: #999999;
            display: inline-block;
            padding-left: 1rem;
            color: #54ceec !important;
            // width: 4.5rem;
            border-left: 4px solid #54ceec;
        }
    }
    .advice {
        position: absolute;
        margin: 1.5rem 0 0 0;
        background-color: #ffffff;
        border-radius: 10px;
        // width: 100%;
        // height: 100%;
        // padding: 1rem 0 0 0;
    }
    .no_advice{
        // padding: 1rem 0 0 0;
    }
}

.userRight {
    width: 70%;
    max-width: 1400px;
    // height: 120vh;
    border-radius: 15px;
    background-color: #fff;
}
</style>